import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="max-w-3xl mx-auto px-6 md:px-10 py-20 md:py-28">
      <div className="chop-card chop-shadow p-8 md:p-14 text-center">
        <XCircle className="w-14 h-14 mx-auto text-[#1A6B2E]" />
        <h1 className="font-display text-4xl md:text-5xl mt-6 tracking-tighter">Payment cancelled</h1>
        <p className="text-[#4E5C4F] mt-3">Your cart's untouched. Come back when you're hungry.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/menu" className="rounded-full border border-[#1A6B2E]/15 px-6 py-3 text-sm hover:bg-[#F4EFEB]">
            Back to menu
          </Link>
          <Link to="/checkout" className="btn-primary rounded-full px-6 py-3 text-sm font-semibold">
            Try again
          </Link>
        </div>
      </div>
    </main>
  );
}
